"use client";
export { Paragraph as default } from "../../../_Builtin/Typography";
